import React from "react";
import {
  connect
} from "react-redux";
import {
  getArticles,
  getCategories,
  removeArticle
} from "../../actions/freelancer";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
} from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";

import DropdownSelection from '../../components/Commons/DropdownSelection';
import SearchBar from '../../components/Commons/SearchBar';
import ArticleTable from '../../components/freelancer/ArticleTable';
import PaginationBar from '../../components/Commons/PaginationBar';

const CATEGORIES = [
  {
    "id": 1,
    "parent_id": null,
    "sort": null,
    "name": "news",
    "display_name": "新聞"
  },
  {
    "id": 101,
    "parent_id": null,
    "sort": null,
    "name": "events",
    "display_name": "活動"
  },
  {
    "id": 105,
    "parent_id": null,
    "sort": null,
    "name": "business info",
    "display_name": "商業"
  },
  {
    "id": 108,
    "parent_id": null,
    "sort": null,
    "name": "lives",
    "display_name": "生活資訊"
  },
  {
    "id": 114,
    "parent_id": null,
    "sort": null,
    "name": "southern plaza",
    "display_name": "美南廣場"
  }
]
class FreelancerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      articles: [],
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.filterAuthor = this.filterAuthor.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { category_id } = urlParams;
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams,
      activeCategoryType: activeCategoryType
    });
    this.getCategories();
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  getCurrentCategory(category_id) {
    var matchRoles = CATEGORIES.filter(value => {
      return value.id == category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType
  }


  getCategories() {
    this.props.getCategories();
  }

  hideAlert() {
    this.setState({
      alert: ""
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: ""
    });
    let post_id = row.post.id;
    this.props.removeArticle({ post_id });
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.post.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      )
    });
  }


  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterAuthor(author_id) {
    // const activeCategoryType = this.getCurrentCategory(author_id);
    // this.setState({
    //   activeCategoryType: activeCategoryType
    // });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      author_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }



  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      categories,
    } = this.props.freelancer;
    var activeCategoryType = this.state.activeCategoryType;

    const heads = ['狀態', '標題', '分類', '作者', '發布日期', '浏览量', '操作'];
    const dataAttributes = ['status', 'title', 'category', 'author', 'created_at',];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between">
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <DropdownSelection Types={categories} activeType={activeCategoryType} filterType={this.filterCat} />
              </div>
              <div className="d-flex align-items-center">
                <SearchBar search_string={this.state.title} onSearchInputChange={this.onSearchInputChange} />
              </div>

            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            remove={this.removeArticle}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={page => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    freelancer: state.freelancer,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArticles: params => dispatch(getArticles(params)),
    getCategories: params => dispatch(getCategories(params)),
    removeArticle: params => dispatch(removeArticle(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FreelancerPage);